import { render } from "./moh705a.vue?vue&type=template&id=9fe37046&scoped=true"
import script from "./moh705a.vue?vue&type=script&lang=js"
export * from "./moh705a.vue?vue&type=script&lang=js"

import "./moh705a.vue?vue&type=style&index=0&id=9fe37046&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fe37046"]])

export default __exports__